import React from 'react'
import { Input } from '@guillotinaweb/react-gmi'
import { Form } from '@guillotinaweb/react-gmi'
import { useSetState } from 'react-use'
import { stringToSlug } from '@guillotinaweb/react-gmi'
import { Loading } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { useLocation } from '@guillotinaweb/react-gmi'
import { Select } from '@guillotinaweb/react-gmi'
import { I18NField } from '../../components/i18nfield'
import { ErrorZone } from '../../components/error_zone'
import { LANGS } from '../../consts'
import { sleep } from '../../utils'
import { Button } from '@guillotinaweb/react-gmi'

import { useState } from 'react'

const MESSAGES = {
  tag_type_required: 'Debes especificar un tipo de tag',
  uva_nombre_required: 'El campo nombre es obligatorio',
}

const processTypes = (data) => {
  return data.member.map((item) => ({
    text: item.title || item.id,
    value: item.path,
  }))
}

const prepareData = (data) => {
  const result = {
    slug: {},
    ...data,
    '@type': 'Tag',
  }

  if (result.type !== '/tags/uva') {
    delete result.id
  }

  LANGS.map((lang) => {
    if (result.localized_text[lang] === '') {
      result.localized_text[lang] = result.localized_text.es
    }
    // patch slugs
    result.slug[lang] = stringToSlug(result.localized_text[lang])
  })
  return result
}

export function TagForm() {
  const Ctx = useTraversal()
  const [, navigate] = useLocation()
  const [tipos, setTipos] = useState(undefined)
  const [state, setState] = useSetState({ type: '', localized_text: {} })
  const [error, setError] = useState(undefined)
  const [loading, setLoading] = useState(false)

  React.useEffect(() => {
    // Get current tag from context, removing leading, and trail /
    const path = Ctx.path.split('/').slice(1, -1)
    if (path.length >= 2) {
      setState({ type: `/tags/${path[1]}` })
    }
  }, [])

  React.useEffect(() => {
    ;(async () => {
      let data = await Ctx.client.getItems('/tags/', 0, 100)
      setTipos(processTypes(data))
    })()
  }, [])

  const submit = async () => {
    if (state.type === '') {
      setError('tag_type_required')
      return
    }
    if (!state.localized_text.es || state.localized_text.es === '') {
      setError('uva_nombre_required')
      return
    }
    const { type, ...data } = prepareData(state)
    const path = type
    setLoading(true)

    const result = await Ctx.client.post(path + '/', data)
    const response = await result.json()
    if (result.status === 201) {
      await sleep(1000)
      Ctx.flash('Tag creado', 'success')
      Ctx.cancelAction()
      navigate({ path: `${type}/${response['@name']}/` }, true)
    } else if (result.status === 409) {
      setLoading(false)
      setError('An error has ocurred: This ID already exists')
    } else {
      setLoading(false)
      const errorMsg =
        response.error?.message || response.message || result.status
      setError(`Server Error: ${errorMsg}`)
    }
  }

  return (
    <Form onSubmit={submit}>
      <h1 className="title is-size-4 has-text-primary">Añadir Tag</h1>
      {!tipos && <Loading />}
      {tipos && (
        <React.Fragment>
          {error && (
            <ErrorZone className="is-size-7">
              {MESSAGES[error] || error}
            </ErrorZone>
          )}
          <div className="field">
            <label className="label">Tipo de Tag</label>
            <Select
              value={state.type}
              options={tipos}
              appendDefault
              onChange={(ev) => setState({ type: ev.target.value })}
              classWrap={'is-small'}
            />
          </div>
          <I18NField
            label="Nombre"
            onChange={(ev) => {
              const id = ev.es !== '' ? stringToSlug(ev.es).substring(0, 3) : ''
              setState({ localized_text: ev, id: id })
            }}
          />

          {state.type === '/tags/uva' && (
            <div className="field">
              <Input
                className="is-size-6"
                onChange={(ev) => setState({ id: ev })}
                id="ID"
                placeholder="id_uva"
                value={state.id}
              />
            </div>
          )}

          <p>&nbsp;</p>
          <div className="level level-right">
            <Button className="is-primary" loading={loading}>
              Añadir
            </Button>
          </div>
        </React.Fragment>
      )}
    </Form>
  )
}
